import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { VelicinaSet } from './velicina-set';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-velicina-set',
  templateUrl: './velicina-set.component.html'
})
export class VelicinaSetComponent
 extends BaseModalContainer<VelicinaSet>
  implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<VelicinaSet>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
  }

  ngOnInit() {
  }

}
